import * as React from 'react';
import { useIsMobile, useIsDesktop, useIsNotDesktop, useIsNotMobile, useIsTablet } from './utils/deviceHooks';

export interface IMediaQueryProps {
  children: React.ReactElement;
}

/**
 * Все что с шириной экрана от 1024px
 */
export const Desktop = ({ children }: IMediaQueryProps) => {
  const needRender = useIsDesktop();

  return needRender ? children : null;
};

/**
 * Все что с шириной экрана до 1023px
 */
export const NotDesktop = ({ children }: IMediaQueryProps) => {
  const needRender = useIsNotDesktop();

  return needRender ? children : null;
};

/**
 * Все что с шириной экрана от 768px до 1023px
 */
export const Tablet = ({ children }: IMediaQueryProps) => {
  const needRender = useIsTablet();

  return needRender ? children : null;
};

/**
 * Все что с шириной экрана до 767px
 */
export const Mobile = ({ children }: IMediaQueryProps) => {
  const needRender = useIsMobile();

  return needRender ? children : null;
};

/**
 * Все что с шириной экрана 768px и больше
 */
export const NotMobile = ({ children }: IMediaQueryProps) => {
  const needRender = useIsNotMobile();

  return needRender ? children : null;
};
